// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3pOLL","list":"BalanceDue_list__27UtC","listRow":"BalanceDue_listRow__3P8za","total":"BalanceDue_total__1dCkk"};